module.exports = __webpack_public_path__ + "static/media/integration1.943a5b61.png";